import $ from 'jquery';

var $polygons = $('.polygon');
$polygons.toArray().forEach(function (item, i) {
    var observer = new IntersectionObserver(
        function (entries, observer) {
            var isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0;
            if (isIntersecting) {
                $(item).closest('.frame, .subpage-header').find('.polygon').addClass('polygon--animate');
                observer.unobserve(item);
            }
        }, {'rootMargin': "-100px 0px"}
    );

    observer.observe(item);
})